import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RewardLogsState } from './reward-logs.state';

export const selectRewardLogsState = createFeatureSelector<RewardLogsState>('adminRewardLogs');

export const selectAllRewardLogs = createSelector(
  selectRewardLogsState,
  (state) => state.rewardLogs,
);

export const selectRewardLogsLoading = createSelector(
  selectRewardLogsState,
  (state) => state.loading,
);

export const selectRewardLogsError = createSelector(
  selectRewardLogsState,
  (state) => state.error,
);

export const selectRewardLogsPagination = createSelector(
  selectRewardLogsState,
  (state) => state.pagination,
);

